import React, { useEffect, useState } from "react";
import Section from "./Section";
import DebitsListing from "./DebitsListing";
import { getCreditsHistory } from "../../../../api/orders";
import { Container } from "reactstrap";
import SmallLoader from "../../../../helpers/Common/SmallLoader";
import { Helmet } from "react-helmet-async";

const PurchasedCandidates = () => {
  const [purchasedCandidates, setPurchasedCandidates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getCandidates = async () => {
      try {
        const response = await getCreditsHistory(1, 10);
        console.log("##PurchasedCandidates:", response?.data?.data);
        // If your ajax() returns the API response directly
        setPurchasedCandidates(response?.data?.data || []);

        // If your ajax() wraps axios response, use:
        // setPurchasedCandidates(response?.data?.data || []);
      } catch (err) {
        console.log("err::", err);
      } finally {
        setIsLoading(false);
      }
    };

    getCandidates();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Purchased Candidates | Webvi</title>
      </Helmet>

      <Section />

      <Container className="py-5">
        {isLoading ? (
          <SmallLoader />
        ) : (
          <DebitsListing debitList={purchasedCandidates} />
        )}
      </Container>
    </div>
  );
};

export default PurchasedCandidates;
